module.exports = __webpack_public_path__ + "static/nxrt-automotive11-f70aa0a69698f2fd72d3ea3c34e8c46c.jpg";